import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { IUserSkill } from '../interface/user';

interface IGetUserSkillParameters {
  userId?: string;
  matterId?: string;
}
export const useGetUserSkill = (parameters: IGetUserSkillParameters) => {
  const { userId, matterId } = parameters;
  const url = API_URLS.USER_SKILL.replace(':userId', userId ?? '');
  const { data, isLoading, error, refetch } = useQuery<IUserSkill>({
    queryKey: ['user-skill', userId, matterId],
    queryFn: () => get(url, { matterId }),
    enabled: !!userId && !!matterId,
  });

  return { data: error ? undefined : (data ?? null), isLoading, error, refetch };
};
